export const DAYS_IN_MONTH = 30;

export interface IPlanTimeLeft {
    unit: 'day' | 'month';
    count: number;
}

export const getPlanTimeLeft = (daysLeft?: number | null): IPlanTimeLeft | null => {
    if (typeof daysLeft !== 'number' || !Number.isFinite(daysLeft) || daysLeft <= 0) return null;
    if (daysLeft > DAYS_IN_MONTH) return { unit: 'month', count: Math.floor(daysLeft / DAYS_IN_MONTH) };
    return { unit: 'day', count: daysLeft };
};
